import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RtPlatformService} from '../../../rt-platform/rt-platform.service';
import {SubmissionSeries} from '../../../dashboard/symbols/submission-series.symbols';
import {SubmissionAdditionalDataBackendModel, SubmissionAdditionalDataForm} from '../../types';

@Injectable()
export class DashboardSupplementalHealthService {
  constructor(private http: HttpClient, private platform: RtPlatformService) {}

  /**
   * Load submission additional data by submission id.
   */
  public loadSubmissionAdditionalData(submissionId: SubmissionSeries[`id`]): Observable<SubmissionAdditionalDataBackendModel> {
    const url = `${this.platform.baseUrl}/api/submission-series/additional-data/${submissionId}/`;
    return this.http.get<SubmissionAdditionalDataBackendModel>(url);
  }

  /**
   * Manage submission additional data.
   */
  public manageSubmissionAdditionalData(
    submissionId: SubmissionSeries[`id`],
    submissionAdditionalData: Partial<SubmissionAdditionalDataForm>,
    isUpdate = false
  ): Observable<SubmissionAdditionalDataBackendModel> {
    const url = `${this.platform.baseUrl}/api/submission-series/additional-data/${submissionId}/`;

    // Send PATCH request if an existing backend model should be updated.
    if (isUpdate) {
      return this.http.patch<SubmissionAdditionalDataBackendModel>(url, submissionAdditionalData);
    }

    // Send POST request if a new backend model should be created.
    return this.http.post<SubmissionAdditionalDataBackendModel>(url, submissionAdditionalData);
  }
}
